import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { Text } from "@amzn/stencil-react-components/text";
import React from "react";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BB_APPOINTMENT_DETAIL_PAGE_URL, buildUrl } from "../../config/urls";
import { fetcher } from "../../helpers/fetcher";
import { getSettings } from "../../helpers/get-settings";
import { StatusEnum } from "../../hoc/with-status";
import { TaskAction } from "../task/action";
import useArb from "../../hooks/use-arb";
type UrlParams = {
  applicationId: string;
  requisitionId: string;
};

export type AppointmentDetailsTaskParams = {
  status: StatusEnum;
};

export const AppointmentDetailsTask = ({ status }: AppointmentDetailsTaskParams) => {
  const { applicationId, requisitionId } = useParams<UrlParams>();

  const [loading, setLoading] = useState(true);
  const [appointmentDetailsLink, setAppointmentDetailsLink] = useState<string>("");

  const requestAppointmentDetailsLink = useCallback(async () => {
    setLoading(true);

    // Does not throw
    const settings = await getSettings();
    let url;

    try {
      const response = await fetcher("/api/appointment-details-link");
      url = response.url + "&requisitionId={requisitionId}&applicationId={applicationId}";
    } catch (e) {
      url = BB_APPOINTMENT_DETAIL_PAGE_URL[settings.stage];
    }

    setAppointmentDetailsLink(buildUrl(url, { stage: settings.stage, applicationId, requisitionId }));
    setLoading(false);
  }, []);

  useEffect(() => {
    requestAppointmentDetailsLink();
  }, []);

  const bundle = useArb("HVHChecklistPantherResource");
  const loadingText = bundle.getMessage("Checklist-MainPage-Appointment-Loading");
  const viewAppointmentDetailsText = bundle.getMessage("Checklist-MainPage-Appointment-Details");
  const viewAppointmentButtonText = bundle.getMessage("Checklist-MainPage-Appointment-ButtonText");

  const task = {
    titleText: "View pre-hire appointment details",
    details: null,
    buttonText: viewAppointmentButtonText,
    disableWhenCompleted: true,
    href: appointmentDetailsLink,
    analyticsOnAction: "appointment details",
  };

  if (loading) {
    return <Spinner size={SpinnerSize.Small} loadingText={loadingText} showText={true}></Spinner>;
  }

  return (
    <>
      <Row>
        <Col>
          <Text>{viewAppointmentDetailsText}</Text>
        </Col>
      </Row>
      <Row>
        <TaskAction
          applicationId={applicationId}
          task={task}
          disabled={status === StatusEnum.COMPLETED && task.disableWhenCompleted}
        />
      </Row>
    </>
  );
};
